import React from "react";
import GitHubCalendar from "react-github-calendar";
import {Row} from "react-bootstrap";

function Github() {
    // const [userId, setUserId] = useState(11011159);
    // const [setActivities] = useState([]);
    // const accessToken = 'glpat-1EniFY6ifLiUZ5vAuQKq'; // Ganti dengan token akses GitLab Anda
    //
    // useEffect(() => {
    //     const fetchUserId = async () => {
    //         try {
    //             const response = await axios.get('https://gitlab.com/api/v4/user', {
    //                 headers: {
    //                     Authorization: `Bearer ${accessToken}`
    //                 }
    //             });
    //             setUserId(response.data.id);
    //             // console.log("test ", response)
    //         } catch (error) {
    //             console.error('Error fetching user ID:', error);
    //         }
    //     };
    //
    //     fetchUserId();
    // }, [accessToken]);

    // useEffect(() => {
    //     if (userId) {
    //         const fetchActivities = async () => {
    //             try {
    //                 const response = await axios.get(`https://gitlab.com/api/v4/users/${userId}/events`, {
    //                     headers: {
    //                         Authorization: `Bearer ${accessToken}`
    //                     }
    //                 });
    //                 setActivities(response.data);
    //                 // console.log("cek :", response.data)
    //             } catch (error) {
    //                 console.error('Error fetching activities:', error);
    //             }
    //         };
    //
    //         fetchActivities();
    //     }
    // }, [userId, accessToken]);

    // const formatActivities = () => {
    //     const dateCount = {};
    //     activities.forEach(activity => {
    //         const date = new Date(activity.created_at).toISOString().split('T')[0];
    //         dateCount[date] = (dateCount[date] || 0) + 1;
    //     });
    //
    //     return Object.keys(dateCount).map(date => ({
    //         date,
    //         count: dateCount[date],
    //     }));
    // };

    // const values = formatActivities();
    // console.log('Formatted values:', values); // Tambahkan log untuk debugging

    // const until = new Date().toISOString().split('T')[0];
    // const panelColors = ['#dddddd', '#d6e685', '#8cc665', '#44a340', '#1e6823'];


    return (
        <Row style={{justifyContent: "center", paddingBottom: "10px"}}>
            <h1 className="project-heading" style={{paddingBottom: "20px"}}>
                Days I <strong className="purple">Code</strong>
            </h1>
            <GitHubCalendar
                username="yantodev"
                blockSize={15}
                blockMargin={5}
                color="#c084f5"
                fontSize={16}
            />
            {/*<div>*/}
            {/*    <h1>GitLab Activity Calendar</h1>*/}
            {/*    {userId && activities ? (*/}
            {/*            <GitHubCalendar values={values} until={until} panelColors={panelColors} />*/}
            {/*        // <GitlabCalendar data={values} />*/}
            {/*    ): ''}*/}
            {/*    /!*<GitlabCalendar*!/*/}
            {/*    /!*    baseUrl="https://gitlab.com/yantodev"*!/*/}
            {/*    /!*    // projectId="123456"*!/*/}
            {/*    /!*    accessToken="glpat-1EniFY6ifLiUZ5vAuQKq"*!/*/}
            {/*
            {/*    <CalendarHeatmap*/}
            {/*        startDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}*/}
            {/*        endDate={new Date()}*/}
            {/*        values={values}*/}
            {/*        classForValue={(value) => {*/}
            {/*            if (!value) {*/}
            {/*                return 'color-empty';*/}
            {/*            }*/}
            {/*            return `color-gitlab-${value.count}`;*/}
            {/*        }}*/}
            {/*        tooltipDataAttrs={value => {*/}
            {/*            return {*/}
            {/*                'data-tip': value.date ? `${value.date}: ${value.count} activities` : 'No data'*/}
            {/*            };*/}
            {/*        }}*/}
            {/*        showWeekdayLabels={true}*/}
            {/*    />*/}
            {/*</div>*/}
        </Row>
    );
}

export default Github;
